export const prebasiclessons: any[]= [
    { id:'615',name: 'Identidad y Autonomía' },
    { id:'617',name: 'Convivencia y Ciudadanía' },
    { id:'19',name: 'Corporalidad y Movimiento' },
    { id:'18',name: 'Lenguaje Verbal' },
    { id:'17',name: 'Lenguaje Artístico' },
    { id:'618',name: 'Exploración del Entorno Natural' },
    { id:'619',name: 'Comprensión del Entorno Sociocultural' },
    { id:'14',name: 'Pensamiento Matemático' }
   
  ];